import { render, staticRenderFns } from "./KeywordsTable.vue?vue&type=template&id=2479f0aa&"
import script from "./KeywordsTable.vue?vue&type=script&lang=js&"
export * from "./KeywordsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports